export default __webpack_public_path__ + "static/media/bsp1.0ca98d50.png";